import { BCMSDate } from "@bcm-dev/bcms-vite";

/**
 * @class TASPositivePayAddChecksPageCheckForm
 * @classdesc Class definition for controlling a check
 * form which will then be transformed into a positive pay check.
 * 
 * @property {STRING} _accountID - The account id to filter by.
 */
export default class TASPositivePayAddChecksPageCheckForm {
    _id
    _accountName
    _accountNumber
    _issuedDate
    _checkNumber
    _amount
    _payee
    _referenceNumber
    _type
    _mobileViewIsOpen 
    _mobileViewIsEditing

    constructor(record) {
        this.id = record.id;
        this.accountName = record.accountName;
        this.accountNumber = record.accountNumber;
        this.issuedDate = record.issuedDate;
        this.checkNumber = record.checkNumber;
        this.amount = record.amount;
        this.payee = record.payee;
        this.referenceNumber = record.referenceNumber;
        this.type = record.type;
        this.mobileViewIsOpen = record.mobileViewIsOpen;
        this.mobileViewIsEditing = record.mobileViewIsEditing;
    }

    /**
     * @name id
     * @instance
     * @property set {STRING} - sets the id
     * @memberof TASPositivePayAddChecksPageCheckForm
     */
    set id(value) { this._id = value; }

    /**
     * @name accountName
     * @instance
     * @property set {STRING} - sets the accountName
     * @memberof TASPositivePayAddChecksPageCheckForm
     */
    set accountName(value) { this._accountName = value; }

    /**
     * @name accountNumber
     * @instance
     * @property set {STRING} - sets the accountNumber
     * @memberof TASPositivePayAddChecksPageCheckForm
     */
    set accountNumber(value) { this._accountNumber = value; }

    /**
     * @name issuedDate
     * @instance
     * @property set {STRING} - sets the issuedDate
     * @memberof TASPositivePayAddChecksPageCheckForm
     */
    set issuedDate(value) { this._issuedDate = value; }

    /**
     * @name checkNumber
     * @instance
     * @property set {STRING} - sets the checkNumber
     * @memberof TASPositivePayAddChecksPageCheckForm
     */
    set checkNumber(value) { this._checkNumber = value; }

    /**
     * @name mobileViewIsOpen
     * @instance
     * @property set {STRING} - sets the mobileViewIsOpen
     * @memberof TASPositivePayAddChecksPageCheckForm
     */
    set mobileViewIsOpen(value) { this._mobileViewIsOpen = value; }

    /**
     * @name mobileViewIsEditing
     * @instance
     * @property set {STRING} - sets the mobileViewIsEditing
     * @memberof TASPositivePayAddChecksPageCheckForm
     */
    set mobileViewIsEditing(value) { this._mobileViewIsEditing = value; }

    /**
     * @name amount
     * @instance
     * @property set {STRING} - sets the amount
     * @memberof TASPositivePayAddChecksPageCheckForm
     */
    set amount(value) { this._amount = value; }

    /**
     * @name payee
     * @instance
     * @property set {STRING} - sets the payee
     * @memberof TASPositivePayAddChecksPageCheckForm
     */
    set payee(value) { this._payee = value; }

    /**
     * @name referenceNumber
     * @instance
     * @property set {STRING} - sets the referenceNumber
     * @memberof TASPositivePayAddChecksPageCheckForm
     */
    set referenceNumber(value) { this._referenceNumber = value; }

    /**
     * @name type
     * @instance
     * @property set {STRING} - sets the type
     * @memberof TASPositivePayAddChecksPageCheckForm
     */
    set type(value) { this._type = value; }

    /**
     * @name id
     * @instance
     * @property get {STRING} - returns the id
     * @memberof TransactionSearch
     */
    get id() { return this._id; }

    /**
     * @name accountName
     * @instance
     * @property get {STRING} - returns the accountName
     * @memberof TransactionSearch
     */
    get accountName() { return this._accountName; }

    /**
     * @name accountNumber
     * @instance
     * @property get {STRING} - returns the accountNumber
     * @memberof TransactionSearch
     */
    get accountNumber() { return this._accountNumber; }

    /**
     * @name issuedDate
     * @instance
     * @property get {STRING} - returns the issuedDate
     * @memberof TransactionSearch
     */
    get issuedDate() { return this._issuedDate; }

    /**
     * @name checkNumber
     * @instance
     * @property get {STRING} - returns the checkNumber
     * @memberof TransactionSearch
     */
    get checkNumber() { return this._checkNumber; }

    /**
     * @name mobileViewIsOpen
     * @instance
     * @property get {STRING} - returns the mobileViewIsOpen
     * @memberof TransactionSearch
     */
    get mobileViewIsOpen() { return this._mobileViewIsOpen; }

    /**
     * @name mobileViewIsEditing
     * @instance
     * @property get {STRING} - returns the mobileViewIsEditing
     * @memberof TransactionSearch
     */
    get mobileViewIsEditing() { return this._mobileViewIsEditing; }

    /**
     * @name amount
     * @instance
     * @property get {STRING} - returns the amount
     * @memberof TransactionSearch
     */
    get amount() { return this._amount; }

        /**
     * @name payee
     * @instance
     * @property get {STRING} - returns the payee
     * @memberof TransactionSearch
     */
    get payee() { return this._payee; }

    /**
     * @name referenceNumber
     * @instance
     * @property get {STRING} - returns the referenceNumber
     * @memberof TransactionSearch
     */
    get referenceNumber() { return this._referenceNumber; }

    /**
     * @name type
     * @instance
     * @property get {STRING} - returns the type
     * @memberof TransactionSearch
     */
    get type() { return this._type; }

    /**
     * @name filters
     * @instance
     * @property get {OBJECT} - returns the set filter properties
     * @memberof TASPositivePayAddChecksPageCheckForm
     */
    // TO DO: This code is from class "TransactionSearch" and similar support may be needed
    // once we have data to filter.
    /*get filters() {
        return Object.getOwnPropertyNames(this).reduce((result, name) => {
            const key = name.slice(1);
            const value = this[key];

            if(value !== undefined && value !== "" && (key !== "ranges" && key !== "types")){
                result[key] = value;
            }

            return result;
        }, {});
    }*/
    
    /**
     * @name record
     * @instance
     * @property get {OBJECT} - returns the set values
     * @memberof TASPositivePayAddChecksPageCheckForm
     */
    get record() {
        return {
            id: this.id,
            accountName: this.accountName,
            accountNumber: this.accountNumber,
            issuedDate: this.issuedDate,
            checkNumber: this.checkNumber,
            amount: this.amount,
            payee: this.payee,
            referenceNumber: this.referenceNumber,
            type: this.type,
            mobileViewIsOpen: this.mobileViewIsOpen,
            mobileViewIsEditing: this.mobileViewIsEditing,
        };
    }

    // TO DO: This code is from class "TransactionSearch" and similar support may be needed
    // once we have data to filter.
    /*checkValue(transaction, key) {
        switch(key) {
            case "date":
                return transaction.date.isAfter(BCMSDate.init().offset(this.date));
    
            case "description":
                return transaction.description.toLowerCase().indexOf(this.description.toLowerCase()) > -1;
    
            case "type":
                return this.type === "all" ? true : transaction.filterType === this.type;
    
            case "amount":
                const amount = parseFloat(transaction.amount.amount);
                return parseFloat(this.amount.amount) === (amount < 0 ? -amount : amount);
    
            case "check":
                const desc = transaction.description;
                return desc.toLowerCase().indexOf("check") > -1 && desc.indexOf(this.check) > -1;
    
            default:
                return true;
        }
    }*/

    // TO DO: This code is from class "TransactionSearch" and similar support may be needed
    // once we have data to filter.
    /*filter() {
        return Transaction.initByAccount(this.accountID)
            .filter(transaction => {
                return Object.keys(this.filters).reduce((result, key) => {
                    if(!this.checkValue(transaction, key)) {
                        result = false;
                    }

                    return result;
                }, true);
            }, []);
    }*/

    reset() {
        const vals = { 
            id: "0",
            accountName: "undefined",
            accountNumber: "xundefined", 
            issuedDate: BCMSDate.init(0),
            checkNumber: "", 
            amount: "",
            payee: "",
            referenceNumber: "",
            type: "issue",
            mobileViewIsOpen: true, 
            mobileViewIsEditing: true 
        };
        return TASPositivePayAddChecksPageCheckForm.init(vals);
    }
    
    static init(record) {
        const vals = { 
            id: "0",
            accountName: "undefined",
            accountNumber: "xundefined", 
            issuedDate: BCMSDate.init(0),
            checkNumber: "", 
            amount: "",
            payee: "",
            referenceNumber: "",
            type: "issue",
            mobileViewIsOpen: true, 
            mobileViewIsEditing: true,
            ...record ?? {} 
        }
        return new TASPositivePayAddChecksPageCheckForm(vals);
    }
}